module.exports = __webpack_public_path__ + "static/media/global-company.37e17fb1.png";